export enum ActionType {
  AUTO = 'auto',
  MANUAL = 'manual',
}
